import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MoneyModule } from '@x/common/money';
import { OrderItemDeliveryNoteComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/order/order-item-delivery-note/order-item-delivery-note.component';
import { OrderTotalsComponent } from './order-totals.component';

@NgModule({
  declarations: [OrderTotalsComponent],
  imports: [CommonModule, MoneyModule, OrderItemDeliveryNoteComponent],
  exports: [OrderTotalsComponent],
})
export class OrderTotalModule {}
